module.exports = __webpack_public_path__ + "static/media/by.1ecc5f5d.svg";